<div *ngIf="listaCuentas && listaCuentas.length > 0" class="px-4 sm:px-8 py-4">

  <!-- ═══ TABLA DESKTOP ═══ -->
  <div class="hidden lg:block bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">
    <table mat-table [dataSource]="listaCuentas" class="w-full">

      <!-- Nombre -->
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let row">
          <span style="font-weight: 700; font-size: 0.82rem; color: #111827;">{{ row.beneficiario_nombre }} {{ row.beneficiario_apellido }}</span>
        </td>
      </ng-container>

      <!-- Red -->
      <ng-container matColumnDef="red">
        <th mat-header-cell *matHeaderCellDef>Red</th>
        <td mat-cell *matCellDef="let row">
          <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 4px;">
            <span style="display: inline-flex; align-items: center; gap: 4px; padding: 2px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; background: #fef3c7; color: #92400e; border: 1px solid #fde68a;">
              <mat-icon style="font-size: 12px; width: 12px; height: 12px; color: #f59e0b; flex-shrink: 0;">token</mat-icon>
              {{ row.medioCriptomoneda_descripcion }}
            </span>
            <!-- Red pausada: no bloquea la libreta (se edita y se elimina igual), pero ahora no se le puede enviar -->
            <span *ngIf="pausado(row)" title="Por ahora no puedes enviar a este beneficiario"
              style="display: inline-flex; align-items: center; gap: 3px; padding: 2px 8px; border-radius: 12px; font-size: 0.68rem; font-weight: 700; background: #f3f4f6; color: #374151; border: 1px solid #d1d5db;">
              <mat-icon style="font-size: 12px; width: 12px; height: 12px; color: #6b7280; flex-shrink: 0;">pause_circle</mat-icon>
              Red pausada
            </span>
          </div>
        </td>
      </ng-container>

      <!-- Wallet -->
      <ng-container matColumnDef="wallet">
        <th mat-header-cell *matHeaderCellDef>Wallet</th>
        <td mat-cell *matCellDef="let row">
          <span style="font-size: 0.78rem; color: #2563eb; font-weight: 600; font-family: monospace; word-break: break-all;">{{ row.beneficiario_medio_recepcion }}</span>
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="acciones" stickyEnd>
        <th mat-header-cell *matHeaderCellDef style="text-align: center;">Acciones</th>
        <td mat-cell *matCellDef="let row">
          <div style="display: flex; gap: 4px; justify-content: center; flex-wrap: wrap;">
            <!-- Ver -->
            <button type="button" title="Ver detalle" (click)="verCuenta(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; transition: all 0.2s;"
              onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">visibility</mat-icon>
            </button>
            <!-- Editar -->
            <button type="button" title="Editar" (click)="actualizar(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer; transition: all 0.2s;"
              onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">edit</mat-icon>
            </button>
            <!-- Eliminar -->
            <button type="button" title="Eliminar" (click)="inactivarCuenta(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer; transition: all 0.2s;"
              onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        (click)="seleccionable ? seleccionar(row) : null"
        [style.cursor]="seleccionable ? 'pointer' : 'default'"
        [style.background]="row.seleccionado ? '#f0fdf4' : ''"></tr>
    </table>
  </div>

  <!-- ═══ CARDS MOBILE (colapsables) ═══ -->
  <div class="lg:hidden flex flex-col gap-3">
    <div *ngFor="let cuenta of listaCuentas"
      (click)="seleccionable ? seleccionar(cuenta) : toggleCard(cuenta.beneficiario_id)"
      style="background: white; border-radius: 14px; overflow: hidden; transition: all 0.2s ease;"
      [style.border]="expandedCardId === cuenta.beneficiario_id ? '2px solid #1C593D' : (cuenta.seleccionado ? '2px solid #1C593D' : '1px solid #e5e7eb')"
      [style.box-shadow]="expandedCardId === cuenta.beneficiario_id ? '0 4px 16px rgba(28,89,61,0.1)' : '0 1px 3px rgba(0,0,0,0.06)'">

      <!-- Header siempre visible -->
      <div style="padding: 14px 16px; display: flex; align-items: center; gap: 12px; cursor: pointer;"
        [style.background]="expandedCardId === cuenta.beneficiario_id ? '#f0fdf4' : 'white'">

        <!-- Icono crypto -->
        <div style="display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 10px; background: #fef3c7; flex-shrink: 0;">
          <mat-icon style="font-size: 22px; width: 22px; height: 22px; color: #f59e0b; flex-shrink: 0;">token</mat-icon>
        </div>

        <!-- Nombre + red -->
        <div style="min-width: 0; flex: 1;">
          <p style="font-weight: 700; font-size: 0.9rem; color: #111827; margin: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ cuenta.beneficiario_nombre }} {{ cuenta.beneficiario_apellido }}
          </p>
          <span style="font-size: 0.78rem; color: #6b7280;">{{ cuenta.medioCriptomoneda_descripcion }}</span>
        </div>

        <!-- Badge red (antes decía TRC20 fijo) -->
        <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 3px; flex-shrink: 0;">
          <span style="display: inline-flex; align-items: center; gap: 3px; background: #fef3c7; border: 1px solid #fde68a; padding: 2px 8px; border-radius: 12px; font-size: 0.65rem; font-weight: 600; color: #92400e;">
            {{ etiquetaRed(cuenta) }}
          </span>
          <span *ngIf="pausado(cuenta)"
            style="display: inline-flex; align-items: center; background: #f3f4f6; border: 1px solid #d1d5db; padding: 2px 8px; border-radius: 12px; font-size: 0.62rem; font-weight: 700; color: #374151;">
            Red pausada
          </span>
        </div>

        <!-- Flecha expandir -->
        <mat-icon style="color: #9ca3af; flex-shrink: 0; transition: transform 0.2s ease;"
          [style.transform]="expandedCardId === cuenta.beneficiario_id ? 'rotate(180deg)' : 'rotate(0)'">
          expand_more
        </mat-icon>
      </div>

      <!-- Cuerpo expandible -->
      <div *ngIf="expandedCardId === cuenta.beneficiario_id">
        <!-- Detalles grid 2 cols -->
        <div style="padding: 0 16px 12px; border-top: 1px solid #f3f4f6;">
          <div class="grid grid-cols-2 gap-3" style="padding-top: 12px;">
            <div>
              <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Nombre</span>
              <p style="margin: 2px 0 0; font-size: 0.82rem; font-weight: 600; color: #111827;">{{ cuenta.beneficiario_nombre }}</p>
            </div>
            <div>
              <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Apellido</span>
              <p style="margin: 2px 0 0; font-size: 0.82rem; font-weight: 600; color: #111827;">{{ cuenta.beneficiario_apellido }}</p>
            </div>
            <div class="col-span-2">
              <span style="font-size: 0.68rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Wallet</span>
              <p style="margin: 2px 0 0; font-size: 0.78rem; font-weight: 600; color: #2563eb; font-family: monospace; word-break: break-all;">{{ cuenta.beneficiario_medio_recepcion }}</p>
            </div>
          </div>
        </div>

        <!-- Acciones mobile -->
        <div style="padding: 10px 16px; border-top: 1px solid #f3f4f6; display: flex; gap: 8px;">
          <button type="button" (click)="verCuenta(cuenta); $event.stopPropagation()"
            style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 12px; background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; border-radius: 8px; font-weight: 600; font-size: 0.78rem; cursor: pointer; transition: all 0.2s;"
            onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">visibility</mat-icon>
            Ver
          </button>
          <button type="button" (click)="actualizar(cuenta); $event.stopPropagation()"
            style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 12px; background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; border-radius: 8px; font-weight: 600; font-size: 0.78rem; cursor: pointer; transition: all 0.2s;"
            onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb; flex-shrink: 0;">edit</mat-icon>
            Editar
          </button>
          <button type="button" (click)="inactivarCuenta(cuenta); $event.stopPropagation()"
            style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 12px; background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; border-radius: 8px; font-weight: 600; font-size: 0.78rem; cursor: pointer; transition: all 0.2s;"
            onmouseover="this.style.background='#fee2e2'" onmouseout="this.style.background='#fef2f2'">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0;">delete</mat-icon>
            Eliminar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
